import { PART_TYPES } from './faceParts/data/enums'
import { colorMap } from './helpers/colorHelper'

// An object for each tab
export default [
  {
    partType: PART_TYPES.FACE_SHAPE,
    title: 'avatar.head',
    availableColors: Object.keys(colorMap[PART_TYPES.FACE_SHAPE]),
  },
  { partType: PART_TYPES.HAIR, title: 'avatar.hair', availableColors: Object.keys(colorMap[PART_TYPES.HAIR]) },
  { partType: PART_TYPES.EYES, title: 'avatar.eyes', availableColors: Object.keys(colorMap[PART_TYPES.EYES]) },
  { partType: PART_TYPES.EYEBROWS, title: 'avatar.brows', availableColors: Object.keys(colorMap[PART_TYPES.HAIR]) },
  { partType: PART_TYPES.NOSE, title: 'avatar.nose', availableColors: [] },
  { partType: PART_TYPES.MOUTH, title: 'avatar.mouth', availableColors: Object.keys(colorMap[PART_TYPES.MOUTH]) },
  {
    partType: PART_TYPES.FACIAL_HAIR,
    title: 'avatar.facial-hair',
    availableColors: Object.keys(colorMap[PART_TYPES.HAIR]),
  },
  { partType: PART_TYPES.EARS, title: 'avatar.ears', availableColors: [] },
  {
    partType: PART_TYPES.FACIAL_LINES,
    title: 'avatar.facial-lines',
    availableColors: Object.keys(colorMap[PART_TYPES.FACIAL_LINES]),
  },
  {
    partType: PART_TYPES.GLASSES,
    title: 'avatar.eyewear',
    availableColors: Object.keys(colorMap[PART_TYPES.GLASSES]),
  },
  {
    partType: PART_TYPES.JEWELRY,
    title: 'avatar.jewelry',
    availableColors: Object.keys(colorMap[PART_TYPES.JEWELRY]),
  },
  { partType: PART_TYPES.SHIRT, title: 'avatar.shirts', availableColors: Object.keys(colorMap[PART_TYPES.SHIRT]) },
]
